export const API_MANFREDITE_PATH = '/v2/manfredite';
